import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Star, CheckCircle } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { Product } from '../data/mockData';
interface ProductCardProps {
  product: Product;
  compact?: boolean;
}
export function ProductCard({
  product,
  compact = false
}: ProductCardProps) {
  const navigate = useNavigate();
  if (compact) {
    return <div onClick={() => navigate(`/products/${product.id}`)} className="glass-card overflow-hidden cursor-pointer group" data-id="element-44">
        <div className="aspect-[4/3] relative overflow-hidden" data-id="element-45">
          <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-46" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-47" />
          {product.isVerified && <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-[#00D68F] flex items-center justify-center shadow-[0_0_8px_rgba(0,214,143,0.5)]" data-id="element-48">
              <CheckCircle className="w-4 h-4 text-[#0A0E1A]" data-id="element-49" />
            </div>}
        </div>
        <div className="p-3" data-id="element-50">
          <h4 className="text-white font-bold text-sm mb-1.5 line-clamp-2 tracking-tight" data-id="element-51">
            {product.name}
          </h4>
          <p className="text-[#00D68F] font-bold tracking-tight mb-2" data-id="element-52">
            ₦{product.price.toLocaleString()}
          </p>
          <div className="flex items-center justify-between" data-id="element-53">
            <span className="text-[#64748B] text-xs font-medium truncate" data-id="element-54">
              {product.sellerName}
            </span>
            <div className="flex items-center gap-1" data-id="element-55">
              <Star className="w-3 h-3 text-[#FFBE0B] fill-[#FFBE0B]" data-id="element-56" />
              <span className="text-white text-xs font-bold" data-id="element-57">
                {product.sellerRating}
              </span>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div onClick={() => navigate(`/products/${product.id}`)} className="glass-card glass-card-hover overflow-hidden cursor-pointer group" data-id="element-58">
      {/* Product Image */}
      <div className="h-40 relative overflow-hidden" data-id="element-59">
        <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0E1A] via-transparent to-transparent" data-id="element-61" />
        <div className="absolute top-3 right-3" data-id="element-62">
          <StatusBadge status={product.status} size="sm" data-id="element-63" />
        </div>
        {product.isVerified && product.status === 'approved' && <div className="absolute top-3 left-3 w-7 h-7 rounded-full bg-[#00D68F] flex items-center justify-center shadow-[0_0_10px_rgba(0,214,143,0.5)]" data-id="element-64">
            <CheckCircle className="w-4 h-4 text-[#0A0E1A]" data-id="element-65" />
          </div>}
      </div>

      <div className="p-4" data-id="element-66">
        <h3 className="text-white font-bold text-lg tracking-tight mb-1" data-id="element-67">
          {product.name}
        </h3>
        <p className="text-[#64748B] text-sm mb-3 line-clamp-1 leading-relaxed" data-id="element-68">
          {product.description}
        </p>

        <div className="flex justify-between items-center mb-3" data-id="element-69">
          <span className="text-[#00D68F] font-bold text-xl tracking-tight" data-id="element-70">
            ₦{product.price.toLocaleString()}
          </span>
          <ChevronRight className="w-5 h-5 text-white/20 group-hover:text-[#00D68F] transition-colors" data-id="element-71" />
        </div>

        {/* Seller Info */}
        <div className="flex items-center justify-between pt-3 border-t border-white/[0.04]" data-id="element-72">
          <div className="flex items-center gap-2" data-id="element-73">
            <div className="w-6 h-6 rounded-full bg-gradient-to-br from-[#00D68F] to-[#00B377] flex items-center justify-center text-[#0A0E1A] text-[8px] font-bold" data-id="element-74">
              {product.sellerName.split(' ').map(n => n[0]).join('')}
            </div>
            <span className="text-[#64748B] text-xs font-medium" data-id="element-75">
              {product.sellerName}
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-76">
            <Star className="w-3.5 h-3.5 text-[#FFBE0B] fill-[#FFBE0B]" data-id="element-77" />
            <span className="text-white text-sm font-bold" data-id="element-78">
              {product.sellerRating}
            </span>
          </div>
        </div>

        {product.status === 'approved' && <div className="flex gap-4 mt-3 pt-3 border-t border-white/[0.04] text-xs text-[#64748B] font-medium tracking-wide uppercase" data-id="element-79">
            <span data-id="element-80">{product.views} views</span>
            <span data-id="element-81">{product.sales} sales</span>
          </div>}
      </div>
    </div>;
}